module.exports = __webpack_public_path__ + "static/media/viewbookcategoryicon.36b3a17e.svg";